<template>
  <div class="welcome-container">
    <div class="welcome-card">
      <h1>Welcome to 6buoys!</h1>
      
      <p>Through video coaching from passionate skiers, including the Pros, we'll coach you to the next buoy.</p>
      
      <div class="video-container">
        <video controls preload="metadata" poster="">
          <source src="https://d1fol7lt0lnhog.cloudfront.net/video/de1220c0-421d-48cc-9a00-b32e9f16e62a.mov" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
      
      <p>As a skier who always had limited access to great lakes and good coaches, I built this app to make high level coaching accessible for all skiers in the world!</p>
      
      <ul>
        <li>Post your water skiing videos to receive tips from skiers all over the world</li>
        <li>Request tips from pros</li>
        <li>Share your tips with other skiers! Even if you're not an official coach, your insights could help a skier to the next buoy</li>
      </ul>
      
      <p>Don't hesitate to engage and tip other skiers on the platform. You might share the insight that was much needed to help a skier improve, even if you're not an official coach.</p>
      
      <p>Enjoy the app and let's improve your skiing!</p>
      
      <div class="signature">
        <p>Thomas Slabbers<br>
        <span class="founder">Founder</span></p>
      </div>
      
      <div class="action-buttons">
        <router-link to="/timeline" class="btn primary">Start Exploring</router-link>
        <router-link to="/post/create" class="btn secondary">Post Your First Video</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeMessage'
}
</script>

<style scoped>
.welcome-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px 0px 56px 0px;
  background-color: #15202b;
  margin-bottom: 80px;
}

.welcome-card {
  background-color: #192734;
  border-radius: 15px;
  padding: 25px;
  color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

h1 {
  color: #1DA1F2;
  margin-bottom: 20px;
  font-size: 1.8em;
}

p {
  margin-bottom: 15px;
  line-height: 1.5;
  text-align: left;
}

ul {
  margin: 15px 0;
  padding-left: 20px;
}

li {
  margin-bottom: 10px;
  line-height: 1.4;
  text-align: left;
}

.signature {
  margin-top: 30px;
  font-style: italic;
}

.founder {
  color: #8899a6;
}

.action-buttons {
  display: flex;
  gap: 15px;
  margin-top: 30px;
  flex-wrap: wrap;
}

.btn {
  padding: 10px 20px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: bold;
  text-align: center;
  transition: all 0.3s ease;
}

.primary {
  background-color: #1DA1F2;
  color: white;
}

.primary:hover {
  background-color: #1a91da;
}

.secondary {
  background-color: transparent;
  color: #1DA1F2;
  border: 1px solid #1DA1F2;
}

.secondary:hover {
  background-color: rgba(29, 161, 242, 0.1);
}

.video-container {
  margin: 20px 0;
  border-radius: 10px;
  overflow: hidden;
  background-color: #000;
}

.video-container video {
  width: 100%;
  height: auto;
  display: block;
}

@media screen and (max-width: 600px) {
  .welcome-container {
    padding: 20px 4px 56px 4px;
  }
  
  .welcome-card {
    border-radius: 10px;
    padding: 20px;
  }
  
  .video-container {
    margin: 15px 0;
    border-radius: 8px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
}
</style> 